import { Award, Heart } from 'lucide-react';
import { Link } from 'react-router-dom';

const About = () => {
  const stats = [
    { label: 'Passionate Educator', description: 'On a mission to teach stock market to every Indian', icon: <Heart size={32} /> },
    { label: '4+ Years', description: 'Industry Experience', icon: <Award size={32} /> },
  ];

  const values = [
    {
      title: 'Trust & Transparency',
      description: 'We believe in complete transparency in all our dealings. No hidden charges, no surprises.',
    },
    {
      title: 'Customer First',
      description: 'Your success is our priority. We provide 24/7 support and guidance to help you grow.',
    },
    {
      title: 'Innovation',
      description: 'Leveraging cutting-edge technology to provide the best trading experience.',
    },
    {
      title: 'Education',
      description: 'Empowering investors with knowledge through comprehensive learning resources.',
    },
  ];

  return (
    <div>
      <section className="py-24 md:py-32" style={{ backgroundColor: '#FAFAFA' }}>
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="max-w-3xl mx-auto text-center mb-16">
            <h1
              className="text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-bold mb-6"
              style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              data-testid="about-heading"
            >
              About Dhanamm
            </h1>
            <p className="text-base leading-relaxed" style={{ color: '#475569' }}>
              Registered Angel One Partner. Your trusted partner in the journey to financial freedom. We simplify investing and
              trading for everyone, from beginners to experienced traders.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-2xl mx-auto">
            {stats.map((stat, idx) => (
              <div
                key={idx}
                data-testid={`stat-card-${idx}`}
                className="card-hover bg-[#FFFFFF] border border-[rgba(10,15,26,0.05)] p-8 text-center"
              >
                <div className="flex justify-center mb-4" style={{ color: '#FF5722' }}>
                  {stat.icon}
                </div>
                <h3
                  className="text-2xl font-bold mb-2"
                  style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
                >
                  {stat.label}
                </h3>
                <p className="text-sm" style={{ color: '#475569' }}>
                  {stat.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 md:py-32" style={{ backgroundColor: '#FFFFFF' }}>
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2
                className="text-2xl sm:text-3xl lg:text-4xl tracking-tight font-semibold mb-6"
                style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              >
                Our Mission
              </h2>
              <p className="text-base leading-relaxed mb-6" style={{ color: '#475569' }}>
                At Dhanamm, our mission is to democratize investing and make it accessible to every
                Indian. We partner with Angel One, India's largest retail broking house, to bring you
                the best-in-class trading experience.
              </p>
              <p className="text-base leading-relaxed" style={{ color: '#475569' }}>
                We understand that starting your investment journey can be overwhelming. That's why we
                provide comprehensive guidance, educational resources, and personalized support to help
                you make informed decisions and achieve your financial goals.
              </p>
            </div>
            <div>
              <img
                src="https://images.unsplash.com/photo-1766218331975-ecc29597ce9f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxzdG9jayUyMG1hcmtldCUyMHRyYWRpbmclMjBtb2JpbGV8ZW58MHx8fHwxNzc1NTgyOTIxfDA&ixlib=rb-4.1.0&q=85"
                alt="Mission"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 md:py-32" style={{ backgroundColor: '#FAFAFA' }}>
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="text-center mb-16">
            <h2
              className="text-2xl sm:text-3xl lg:text-4xl tracking-tight font-semibold mb-4"
              style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
            >
              Our Values
            </h2>
            <p className="text-base" style={{ color: '#475569' }}>
              The principles that guide everything we do
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-8">
            {values.map((value, idx) => (
              <div
                key={idx}
                data-testid={`value-card-${idx}`}
                className="card-hover bg-[#FFFFFF] border border-[rgba(10,15,26,0.05)] p-8"
              >
                <h3
                  className="text-xl sm:text-2xl font-semibold mb-3"
                  style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
                >
                  {value.title}
                </h3>
                <p className="text-base" style={{ color: '#475569' }}>
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 md:py-32" style={{ backgroundColor: '#0A0F1A' }}>
        <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-24 text-center">
          <h2
            className="text-2xl sm:text-3xl lg:text-4xl tracking-tight font-semibold mb-6"
            style={{ fontFamily: 'Outfit', color: '#FFFFFF' }}
          >
            Join Us in Building Wealth
          </h2>
          <p className="text-base mb-8" style={{ color: '#94A3B8' }}>
            Start your investment journey with India's most trusted platform
          </p>
          <Link
            to="/brokerage-plans"
            data-testid="about-cta-button"
            className="btn-primary"
            style={{
              backgroundColor: '#FF5722',
              color: 'white',
              fontWeight: 600,
              padding: '1rem 2rem',
              textDecoration: 'none',
              display: 'inline-block',
            }}
          >
            Open Free Demat Account
          </Link>
        </div>
      </section>
    </div>
  );
};

export default About;